import { NgModule } from '@angular/core';

@NgModule()
/**
 * @deprecated since version 1.0.0
 */
export class ToastNotificationClientModule {
}
